(() => {
  const node = document.getElementById('AlpeSecondConfig');
  if (!node || window.AlpeSecondOffer) return;
  const config = JSON.parse(node.textContent);
  const eligibleIds = new Set(config.eligibleIds.map(String));
  const root = window.Shopify?.routes?.root || '/';
  const preview = config.mode === 'preview' && String(window.Shopify?.theme?.id) === config.previewThemeId && window.Shopify?.theme?.role !== 'main';
  if (config.mode === 'preview' && !preview) return;
  const applyCode = preview || config.mode === 'code';
  let pending;
  let dirty = false;
  let lastCart;
  let removing = false;
  const money = amount => {
    const currency = lastCart?.currency || config.currency || 'EUR';
    const number = new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount / 100);
    return currency === 'EUR' ? `${number} €` : new Intl.NumberFormat(document.documentElement.lang || 'sl', { style: 'currency', currency }).format(amount / 100);
  };
  const isBundle = line => !!line.properties?._alpe_bundle_id || /\/products\/(alpe-komplet-|bundle-)/.test(line.url || '');
  const isEligible = line => eligibleIds.has(String(line.product_id)) && !line.gift_card && !isBundle(line) && !line.selling_plan_allocation;
  const allocation = line => (line.line_level_discount_allocations || []).reduce((sum, item) => {
    const title = String(item.discount_application?.title || '').toLowerCase();
    return sum + ([config.code, config.discountTitle].filter(Boolean).some(name => String(name).toLowerCase() === title) ? Number(item.amount) : 0);
  }, 0);
  function state(cart) {
    const items = (cart.items || []).filter(isEligible);
    const count = items.reduce((sum, line) => sum + Number(line.quantity), 0);
    const sorted = [...items].sort((a, b) => Number(a.original_price) - Number(b.original_price) || String(a.key).localeCompare(String(b.key)));
    const cheapest = sorted[0];
    const discounted = sorted.find(line => allocation(line) > 0);
    const saving = items.reduce((sum, line) => sum + allocation(line), 0);
    const confirmed = count >= 2 && discounted && Number(discounted.original_price) === Number(cheapest.original_price) && saving > 0 && Math.abs(saving - Number(cheapest.original_price) / 2) <= 1 && items.every(line => !allocation(line) || line.key === discounted.key);
    const second = confirmed ? discounted : null;
    const first = second ? [...items].sort((a, b) => Number(b.original_price) - Number(a.original_price)).find(line => line.key !== second.key || line.quantity > 1) : items[0];
    return { count, step: count === 0 ? 0 : count === 1 ? 1 : 2, first, second, saving, confirmed, blocked: (cart.items || []).some(isBundle) };
  }
  const groupedLines = new Map();
  const regularIdentity = line => JSON.stringify([
    String(line.variant_id), Number(line.original_price), Number(line.final_price),
    Object.entries(line.properties || {}).sort(([a], [b]) => a.localeCompare(b))
  ]);
  const canGroup = line => isEligible(line) && Number(line.final_line_price) === Number(line.original_line_price) && !(line.line_level_discount_allocations || []).some(discount => Number(discount.amount) > 0);
  function groupCartRows(cart) {
    const byKey = new Map((cart.items || []).map(line => [line.key, line]));
    document.querySelectorAll('[data-products]').forEach(container => {
      const groups = new Map();
      container.querySelectorAll('.cart__item[data-key]').forEach(row => {
        const line = byKey.get(row.dataset.key);
        if (!line || !canGroup(line)) return;
        const identity = regularIdentity(line);
        if (!groups.has(identity)) groups.set(identity, []);
        groups.get(identity).push({ row, line });
      });
      groups.forEach((entries, identity) => {
        if (entries.length < 2) return;
        const first = entries[0];
        const input = first.row.querySelector('.js-qty__num');
        if (!input || first.row.dataset.secondGrouped) return;
        input.value = entries.reduce((sum, entry) => sum + Number(entry.line.quantity), 0);
        input.removeAttribute('name');
        entries.forEach(({ row, line }, index) => {
          const original = document.createElement('input');
          original.type = 'hidden';
          original.name = `updates[${line.key}]`;
          original.value = line.quantity;
          first.row.append(original);
          if (index) row.remove();
        });
        first.row.dataset.secondGrouped = 'true';
        groupedLines.set(first.line.key, identity);
      });
    });
  }
  if (window.theme?.cart) {
    const changeItem = theme.cart.changeItem;
    theme.cart.changeItem = async function(key, quantity) {
      const identity = groupedLines.get(key);
      if (!identity) return changeItem.call(this, key, quantity);
      const cart = await request('cart.js');
      const lines = (cart.items || []).filter(line => canGroup(line) && regularIdentity(line) === identity);
      if (!lines.some(line => line.key === key)) return changeItem.call(this, key, quantity);
      const total = lines.reduce((sum, line) => sum + Number(line.quantity), 0);
      let remaining = Math.max(0, total - Math.max(0, Number(quantity)));
      const updates = {};
      if (Number(quantity) >= total) {
        return changeItem.call(this, lines[0].key, Number(lines[0].quantity) + Number(quantity) - total);
      } else {
        [...lines].reverse().forEach(line => {
          const removed = Math.min(remaining, Number(line.quantity));
          if (removed) updates[line.key] = Number(line.quantity) - removed;
          remaining -= removed;
        });
      }
      return this._updateCart({ url: root + 'cart/update.js', data: JSON.stringify({ updates }) });
    };
  }
  function image(slot, line) {
    const img = slot.querySelector('[data-second-image]');
    const source = line?.featured_image?.url || line?.image;
    const safe = source && /^(https?:\/\/|\/\/|\/)/.test(source);
    const remove = slot.querySelector('[data-second-remove]');
    if (remove) {
      remove.hidden = !line;
      remove.disabled = removing;
      remove.offerLine = line;
      remove.setAttribute('aria-label', `${remove.dataset.label}: ${[line?.product_title || line?.title, line?.variant_title !== 'Default Title' ? line?.variant_title : ''].filter(Boolean).join(' · ')}`);
    }
    slot.classList.toggle('is-filled', !!line);
    img.hidden = !safe;
    if (!safe) { img.removeAttribute('src'); img.alt = ''; return; }
    const url = new URL(source, location.origin);
    url.searchParams.set('width', '320');
    if (img.src !== url.href) img.src = url.href;
    img.alt = [line.product_title || line.title, line.variant_title !== 'Default Title' ? line.variant_title : ''].filter(Boolean).join(' · ');
  }
  function renderTotals(cart) {
    const original = Number(cart.original_total_price || 0);
    const final = Number(cart.total_price || 0);
    const saving = Math.max(0, original - final);
    const totals = document.querySelector('[data-second-cart-totals]');
    if (!totals) return;
    const before = totals.querySelector('[data-second-cart-original]');
    before.hidden = saving <= 0;
    before.textContent = money(original);
    totals.querySelector('[data-second-cart-original-label]').hidden = saving <= 0;
    const finalLabel = totals.querySelector('[data-second-cart-final-label]');
    finalLabel.textContent = saving > 0 ? finalLabel.dataset.sale : finalLabel.dataset.regular;
    totals.querySelector('[data-subtotal]').textContent = money(final);
    totals.classList.toggle('is-discounted', saving > 0);
    const codeLabel = String(config.code || '').toLowerCase();
    document.querySelectorAll('#CartDrawer small.cart__discount').forEach(label => {
      label.classList.toggle('alpe-second-code', !!codeLabel && label.textContent.trim().toLowerCase().startsWith(codeLabel + ' ('));
    });
    const savingRow = document.querySelector('[data-second-cart-saving]');
    if (savingRow) {
      savingRow.hidden = saving <= 0;
      savingRow.querySelector('[data-second-cart-saved]').textContent = money(saving);
    }
  }
  function fitPrices(prices) {
    prices.style.removeProperty('font-size');
    const available = prices.clientWidth - 2;
    if (available <= 0) return;
    const style = getComputedStyle(prices);
    const gap = parseFloat(style.columnGap) || 0;
    const textWidth = [...prices.children].reduce((sum, child) => sum + child.getBoundingClientRect().width, 0);
    if (textWidth + gap <= available) return;
    const size = parseFloat(style.fontSize) * Math.max(0, available - gap) / textWidth;
    prices.style.fontSize = `${Math.floor(size * 100) / 100}px`;
  }
  function render(cart) {
    lastCart = cart;
    const current = state(cart);
    renderTotals(cart);
    groupCartRows(cart);
    document.querySelectorAll('[data-second-offer]').forEach(element => {
      const previousStep = element.dataset.step;
      const previousSecond = element.dataset.secondKey;
      element.hidden = current.blocked || (current.count >= 2 && !current.confirmed);
      element.dataset.step = String(current.step);
      element.dataset.count = String(current.count);
      element.dataset.confirmed = String(!!current.confirmed);
      element.dataset.blocked = String(current.blocked);
      element.dataset.secondKey = current.second?.key || '';
      const secondSlot = element.querySelector('[data-second-slot="2"]');
      secondSlot.classList.toggle('is-unlocked', !!current.confirmed && !element.hidden);
      if (current.confirmed && !element.hidden && (previousStep !== '2' || previousSecond !== current.second.key)) {
        secondSlot.classList.add('is-unlocking');
        clearTimeout(secondSlot.glowTimer);
        secondSlot.glowTimer = setTimeout(() => secondSlot.classList.remove('is-unlocking'), 2600);
      } else if (!current.confirmed || element.hidden) {
        clearTimeout(secondSlot.glowTimer);
        secondSlot.classList.remove('is-unlocking');
      }
      if (element.hidden) return;
      const message = current.step === 0 ? (element.dataset.location === 'drawer' ? config.copy.emptyDrawer : element.getBoundingClientRect().width < 450 ? config.copy.emptyMobile : config.copy.empty) : current.step === 1 ? config.copy.one : config.copy.unlocked.replace('__AMOUNT__', money(current.saving));
      const messageNode = element.querySelector('[data-second-message]');
      if (messageNode.innerHTML !== message) messageNode.innerHTML = message;
      image(element.querySelector('[data-second-slot="1"]'), current.first);
      image(element.querySelector('[data-second-slot="2"]'), current.second);
      const prices = element.querySelector('[data-second-prices]');
      prices.hidden = !current.confirmed;
      if (current.confirmed) {
        element.querySelector('[data-second-original]').textContent = money(Number(current.second.original_price));
        element.querySelector('[data-second-final]').textContent = money(Number(current.second.original_price) - current.saving);
        fitPrices(prices);
      }
      const note = element.querySelector('[data-second-note]');
      if (note) note.textContent = current.step === 0 ? config.copy.noteEmpty : current.step === 1 ? config.copy.noteOne : config.copy.noteUnlocked;
    });
    return cart;
  }
  async function request(path, body) {
    const response = await fetch(root + path, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
    if (!response.ok) throw new Error('Offer cart request failed');
    return response.json();
  }
  async function sync() {
    let cart = await request('cart.js');
    if (applyCode && config.code) {
      const current = state(cart);
      const codes = (cart.discount_codes || []).map(discount => discount.code);
      const owned = [config.code, ...(config.legacyCodes || [])].map(code => code.toLowerCase());
      const ours = codes.some(code => owned.includes(code.toLowerCase()));
      const currentCode = codes.some(code => code.toLowerCase() === config.code.toLowerCase());
      const legacy = codes.some(code => (config.legacyCodes || []).some(old => old.toLowerCase() === code.toLowerCase()));
      const other = codes.filter(code => !owned.includes(code.toLowerCase()));
      if ((current.count < 2 || current.blocked) && ours) {
        cart = await request('cart/update.js', { discount: other.join(',') });
      } else if (current.count >= 2 && !current.blocked && (!currentCode || legacy)) {
        cart = await request('cart/update.js', { discount: [config.code, ...other].join(',') });
      }
    }
    return render(cart);
  }
  function refresh() {
    dirty = true;
    if (pending) return pending;
    pending = (async () => {
      let cart;
      do { dirty = false; cart = await sync(); } while (dirty);
      return cart;
    })().catch(error => {
      document.querySelectorAll('[data-second-offer]').forEach(element => { element.hidden = true; });
      console.warn(error.message);
      return lastCart;
    }).finally(() => { pending = null; });
    return pending;
  }
  window.AlpeSecondOffer = { refresh, state, get cart() { return lastCart; } };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-second-remove]');
    if (!button || removing || !button.closest('[data-location="pdp"]')) return;
    const selected = button.offerLine;
    if (!selected) return;
    const region = button.closest('[data-second-offer]');
    const error = region.querySelector('[data-second-remove-error]');
    error.hidden = true;
    removing = true;
    document.querySelectorAll('[data-second-remove]').forEach(control => { control.disabled = true; });
    try {
      const cart = await refresh();
      if (!cart) throw new Error('Offer cart unavailable');
      const line = cart.items.find(item => item.key === selected.key) || cart.items.find(item => isEligible(item) && item.variant_id === selected.variant_id && JSON.stringify(item.properties || {}) === JSON.stringify(selected.properties || {}));
      if (line) render(await request('cart/change.js', { id: line.key, quantity: Math.max(0, Number(line.quantity) - 1) }));
      const updatedCart = await refresh();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (failure) {
      error.hidden = false;
      console.warn(failure.message);
    } finally {
      removing = false;
      if (lastCart) render(lastCart);
      const focus = region.querySelector('[data-second-remove]:not([hidden])');
      if (focus) focus.focus({ preventScroll: true });
      else { region.setAttribute('tabindex', '-1'); region.focus({ preventScroll: true }); }
    }
  });
  if (window.theme?.CartForm) {
    const buildCart = theme.CartForm.prototype.buildCart;
    theme.CartForm.prototype.buildCart = function(...args) {
      document.getElementById('CartDrawer')?.setAttribute('aria-busy', 'true');
      return refresh().then(() => buildCart.apply(this, args));
    };
  }
  document.addEventListener('alpe:cart-rendered', () => {
    document.getElementById('CartDrawer')?.removeAttribute('aria-busy');
    if (lastCart) { renderTotals(lastCart); groupCartRows(lastCart); }
  });
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('submit', event => {
    if (!pending || !event.target.matches('form[action$="/cart"]')) return;
    const form = event.target;
    const submitter = event.submitter;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending.then(() => { if (submitter?.isConnected) form.requestSubmit(submitter); else form.requestSubmit(); });
  }, true);
  document.addEventListener('pageshow', refresh);
  window.addEventListener('pageshow', event => { if (event.persisted) document.dispatchEvent(new CustomEvent('cart:build')); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') document.dispatchEvent(new CustomEvent('cart:build')); });
  document.addEventListener('shopify:section:load', refresh);
  const sizes = new ResizeObserver(() => { if (lastCart) render(lastCart); });
  document.querySelectorAll('[data-second-offer]').forEach(element => sizes.observe(element.parentElement));
  document.fonts.ready.then(() => { if (lastCart) render(lastCart); });
  refresh();
})();

